<template>
  <div class="img-box">
    <img :src="bgurl" alt="https://oss.aqdpay.com/icon4/gypt_bwbt_new.png">
    <img :src="btnurl" alt="" @click="goDrug">
    <img v-for="(img, index) in imgList" v-lazy="img" :key="index" />
  </div>
</template>
<script>
import { getImgList } from '@/api/eduPush'
export default {
  data () {
    return {
      bgurl: 'https://oss.aqdpay.com/icon4/gypt_bwbt_new.png',
      btnurl: 'https://oss.aqdpay.com/icon4/gypt_qgy_new.png',
      imgList: [
        'https://oss.aqdpay.com/icon4/gypt_hdgz_new.png'
      ]
    }
  },
  created () {
    // this.getList()
  },
  methods: {
    getList () {
      const id = this.$route.query.id
      const requestData = {
        id: id
      }
      getImgList(requestData).then((res) => {
        if (res.data.code === 200) {
          if (res.data) {
            this.bgurl = res.data.result[0]
            this.btnurl = res.dtat.result[1]
            if (res.data.result) {
              const arr = res.data.result
              this.imgList = arr.slice(2)
            }
          }
        }
      })
    },
    goDrug () {
      dsBridge.call('callNativeView', {
        androidGoPage: '/drug/DrugHomeActivity',
        iosGoPage: 'GXGYHomeViewController'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.img-box {
  min-height: 100vh;
  font-size: 0;
  img {
    display: block;
    width: 100%;
  }
}
</style>
